import Trash from "../../../../assets/icons/Trash";
import Button from "../../../../components/general/Button";

export function TrashButton({ onClick }) {
  return (
    <Button
      Icon={() => <Trash />}
      onClick={(event) => {
        event.stopPropagation();
        onClick();
      }}
      square
      size="2.15rem"
      background="#FFBAAB"
      colorText="#D93333"
      activeBackground="#CB9A8F"
    />
  );
}
